import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[0.9fr_1.3fr] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="关于防走丢与入口的疑问"
            desc="收录了关于最新网址、永久入口、防屏蔽与账号安全的最高频问题。仍有疑问可到互助分区发起讨论。"
          />
          <div className="mt-8 hidden rounded-2xl border border-background-200/80 bg-background-50 p-6 lg:block">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
              <i className="ri-shield-keyhole-line"></i>
            </span>
            <h4 className="mt-4 font-heading text-lg font-bold text-foreground-950">小提示</h4>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              判断入口真伪，先看页面底部的永久入口标识与既定域名规则；遇到异常先核对再操作，保护好自己的账号信息。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-xl border transition-colors ${
                  isOpen ? "border-primary-300/70 bg-background-50" : "border-background-200/80 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-[15px] font-semibold text-foreground-950">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}